module.exports = __webpack_public_path__ + "media/7.03d8e522.wav";